import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SyllabusQuery } from '@examdojo/category/v2';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { EMPTY, skip, switchMap } from 'rxjs';
import { UserMarksService } from '../user/mark/user-marks.service';

@Injectable({
  providedIn: 'root',
})
export class FetchUserMarksOnSyllabusChangeEffectService {
  constructor(
    private readonly syllabusQuery: SyllabusQuery,
    private readonly userMarksService: UserMarksService,
    private readonly errorHandlerService: ErrorHandlerService,
  ) {
    this.syllabusQuery.activeIdAndCourseLevel$
      .pipe(
        skip(1),
        switchMap(() =>
          this.userMarksService
            .getUserSpentPointsAndLimits()
            .pipe(this.errorHandlerService.catchHttpErrors(() => EMPTY)),
        ),
        takeUntilDestroyed(),
      )
      .subscribe();
  }
}
